export default __webpack_public_path__ + "static/media/bg.840794cd.webp";